// tslint:disable:no-redundant-jsdoc
/**
 * Parsing Utils
 * @module framework/utils/parse
 */

/**
 * Parse a string to specified object
 * @param input - Assumes string input of type <T>
 */
export function parseToObject<T>(input: string | undefined): T | {} {
    if (input === undefined) return {};

    return new Function(`"use strict";return (${input})`)() as T;
}

